"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = void 0;
// @ts-ignore
const utils_1 = require("../utils");
// @ts-ignore
const indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.OIndexedDB || window.msIndexedDB, 
// @ts-ignore
IDBTransaction = window.IDBTransaction || window.webkitIDBTransaction || window.OIDBTransaction || window.msIDBTransaction, dbVersion = 1.0;
class Loader {
    constructor(name, db) {
        // @ts-ignore
        this.db = db;
        this.name = name;
    }
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.db)
                return true;
            const request = indexedDB.open(this.name, dbVersion);
            return new Promise((resolve, reject) => {
                request.onerror = function (event) {
                    //console.error("Error creating/accessing IndexedDB database", event);
                };
                request.onsuccess = (event) => {
                    this.db = request.result;
                    this.db.onerror = function (event) {
                        //console.error("Error creating/accessing IndexedDB database", event);
                        return reject(`Error creating/accessing IndexedDB database`);
                    };
                    // Interim solution for Google Chrome to create an objectStore. Will be deprecated
                    // @ts-ignore
                    if (this.db.setVersion) {
                        if (this.db.version != dbVersion) {
                            // @ts-ignore
                            const setVersion = this.db.setVersion(dbVersion);
                            setVersion.onsuccess = function () {
                                this.db.createObjectStore(this.name);
                                return resolve(true);
                            };
                        }
                        else {
                            this.db.createObjectStore(this.name);
                            return resolve(true);
                        }
                    }
                    else {
                        return resolve(true);
                    }
                };
                // For future use. Currently only in latest Firefox versions
                request.onupgradeneeded = (event) => {
                    // @ts-ignore
                    this.db = event.target.result;
                    this.db.createObjectStore(this.name);
                };
            });
        });
    }
    deleteItem(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readwrite');
            const request = transaction.objectStore(this.name).delete(name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    return resolve(true);
                };
                request.onerror = (event) => {
                    return reject(`Error saving texture to indexedDB: ${name}`);
                };
            });
        });
    }
    saveBlob(name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readwrite');
            const request = transaction.objectStore(this.name).put(data, name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    return resolve(true);
                };
                request.onerror = (event) => {
                    return reject(`Error saving blob to indexedDB: ${name}`);
                };
            });
        });
    }
    loadBlob(name, decode) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readonly');
            const request = transaction.objectStore(this.name).get(name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    try {
                        if (decode) {
                            // @ts-ignore
                            decode(event.target.result).then(res => {
                                return resolve(res);
                            });
                        }
                        else {
                            // @ts-ignore
                            return resolve(event.target.result);
                        }
                    }
                    catch (err) {
                        return resolve(null);
                    }
                };
                request.onerror = (event) => {
                    return reject(Error(`Error getting texture from indexedDB: ${name}`));
                };
            });
        });
    }
    saveJson(name, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readwrite');
            const request = transaction.objectStore(this.name).put(JSON.stringify(data), name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    return resolve(true);
                };
                request.onerror = (event) => {
                    return reject(`Error saving texture to indexedDB: ${name}`);
                };
            });
        });
    }
    loadJson(name, dontParse = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readonly');
            const request = transaction.objectStore(this.name).get(name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    try {
                        // @ts-ignore
                        const res = dontParse ? event.target.result : JSON.parse(event.target.result);
                        return resolve(res);
                    }
                    catch (err) {
                        return resolve(null);
                    }
                };
                request.onerror = (event) => {
                    return reject(Error(`Error getting texture from indexedDB: ${name}`));
                };
            });
            return null;
        });
    }
    saveTexture(name, texture) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readwrite');
            const canvas = document.createElement('canvas');
            canvas.width = texture.baseTexture.width;
            canvas.height = texture.baseTexture.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(texture.baseTexture.source, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            const request = transaction.objectStore(this.name).put(dataURL, name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    return resolve(true);
                };
                request.onerror = (event) => {
                    return reject(`Error saving texture to indexedDB: ${name}`);
                };
            });
        });
    }
    saveImageData(name, dataUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readwrite');
            const request = transaction.objectStore(this.name).put(dataUrl, name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    return resolve(true);
                };
                request.onerror = (event) => {
                    return reject(`Error saving texture to indexedDB: ${name}`);
                };
            });
        });
    }
    loadImageData(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readonly');
            const request = transaction.objectStore(this.name).get(name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => {
                    // @ts-ignore
                    const imgFile = event.target.result;
                    return resolve(imgFile);
                };
                request.onerror = (event) => {
                    throw new Error(`Error getting texture from indexedDB: ${name}`);
                };
            });
            return null;
        });
    }
    loadTexture(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const transaction = this.db.transaction([this.name], 'readonly');
            const request = transaction.objectStore(this.name).get(name);
            return new Promise((resolve, reject) => {
                request.onsuccess = (event) => __awaiter(this, void 0, void 0, function* () {
                    // @ts-ignore
                    const imgFile = event.target.result;
                    const texture = imgFile ? yield utils_1.dataUrlToTexture(imgFile) : null;
                    return resolve(texture);
                });
                request.onerror = (event) => {
                    throw new Error(`Error getting texture from indexedDB: ${name}`);
                };
            });
            return null;
        });
    }
}
exports.Loader = Loader;
//# sourceMappingURL=module.js.map